import { error} from "../../../components/i18n/i18n";
import { setLoading } from "../generalActions/mainActions";
import { addItem, changeListItem, removeItem, setItems, setTableParams } from "../generalActions/listActions";
import { setForm } from "../generalActions/formActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {busRouteService} from "../../../jwt/_services/eventx/busRouteService";

export const search = (pageIndex, pageSize, filter) => ( dispatch ) => {
    dispatch(setLoading(true))

    busRouteService.search(pageIndex, pageSize, filter)
        .then(result => {
            dispatch(setItems(result?.data))
            dispatch(setTableParams(pageSize, pageIndex, result?.total))
        })
        .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            console.log("Error",error)
        })
        .finally(() => dispatch(setLoading(false)))
}

export const save = data => ( dispatch ) => {
    dispatch(setLoading(true))

    busRouteService.saveItem(data)
        .then( result => {
            dispatch( setForm(false, true, true) )
            dispatch( addItem(result) )
        })
        .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            console.log("Error",error)
        })
        .finally(() => dispatch(setLoading(false)))
}

export const update = (id, data) => ( dispatch ) => {
    dispatch(setLoading(true))

    busRouteService.updateItem(id, data)
        .then( result => {
            dispatch( setForm(false, true, true) )
            dispatch( changeListItem(result) )
        })
        .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            console.log("Error",error)
        })
        .finally(() => dispatch(setLoading(false)))
}

export const remove = (id) => ( dispatch ) => {
    dispatch(setLoading(true))

    busRouteService.deleteItem(id)
        .then( result => {
            if(result?.status)
                dispatch( removeItem(id) )
        })
        .catch(errorMessage => {
            showToastCustom(error, errorMessage);
            console.log("Error",error)
        })
        .finally(() => dispatch(setLoading(false)))
}
